export default __webpack_public_path__ + "static/media/partner (3).47760478.png";